import { render, staticRenderFns } from "./HeaderEncuesta.vue?vue&type=template&id=0c1fa1a4"
import script from "./HeaderEncuesta.vue?vue&type=script&lang=js"
export * from "./HeaderEncuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports